// extracted by mini-css-extract-plugin
export default {"PaymentForm":"PaymentForm_PaymentForm__kokhp"};